import { Controller } from '@hotwired/stimulus';

import nestedy from '@/modules/nestedy';
import Tag from '@/modules/tag';
import Zipcoder from '@/modules/zipcoder';

export default class extends Controller {
  connect() {
    this.bindVideos();
    this.#bindTag();

    new Zipcoder({ scope: 'personal' }).create();
  }

  bindVideos() {
    const videos = this.element.querySelector('[data-videos]');

    if (!videos) return;

    nestedy(videos, {
      change: (count) => document.querySelector('[data-videos-none]').classList.toggle('hidden', count > 0),
      template: '#video-template',
    }).init();
  }

  #bindTag() {
    new Tag({
      field: $('#complety__rhythm'),
      keys: ['name'],
      name: 'teacher[rhythm_ids][]',
      removeImage: this.element.querySelector('[name="tag.removeImage"]').value,
      template: 'rhythms',
      textAttribute: 'name',
      valueAttribute: 'id',
      wrapper: $('.tags'),
    }).create();
  }
}
